
import { Component, Prop, Vue } from 'vue-property-decorator';
import { sitePages, SitePage } from '@/content/site-pages';

/** Link to a page of the site (picked by name) or any other address (typed). Stores the path or URL. */
@Component
export default class LinkField extends Vue {
  @Prop({ required: true }) readonly value!: string;
  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: '' }) readonly hint!: string;
  @Prop({ type: Array, default: () => [] }) readonly errorMessages!: string[];

  pages: SitePage[] = [];

  get paths(): string[] {
    return this.pages.map((page) => page.path);
  }

  async mounted(): Promise<void> {
    this.pages = await sitePages();
  }

  nameOf(path: string): string {
    const page = this.pages.find((candidate) => candidate.path === path);
    return page ? page.name : path;
  }

  /** Search by page name as well as by path. */
  filter(path: string, query: string): boolean {
    const needle = (query || '').toLowerCase();
    return path.toLowerCase().includes(needle) || this.nameOf(path).toLowerCase().includes(needle);
  }

  onChange(next: string | null): void {
    this.$emit('input', typeof next === 'string' ? next.trim() : '');
  }
}
